/**
 * EPLAN attribute code → human-readable label mapping.
 *
 * NOTE: This list is approximate and may not be 100% accurate for all EPLAN versions.
 * Use as a reference aid for AI prompts and UI display — do not rely on it for
 * safety-critical logic.
 */
export const EPLAN_ATTRIBUTE_LABELS = {
    // Allgemeine Attribute
    'A1':  'ID/Referenz',
    'A2':  'Vollständiger Name',
    'A3':  'Typ',
    'A4':  'Beschreibungstext',
    'A5':  'Zusatzfeld 1',
    'A6':  'Zusatzfeld 2',
    'A7':  'Zusatzfeld 3',
    'A8':  'Zusatzfeld 4',
    'A9':  'Zusatzfeld 5',
    'A10': 'Zusatzfeld 6',
    'A11': 'Zusatzfeld 7',
    'A12': 'Zusatzfeld 8',
    'A13': 'Status',
    'A14': 'Variante',
    'A15': 'Revision',
    'A16': 'Freigabedatum',
    'A17': 'Prüfdatum',
    'A18': 'Erstelldatum',
    'A19': 'Änderungsdatum',
    'A20': 'Kommentar',

    // Sichtbarkeit und Anzeige
    'A47': 'Sichtbar',
    'A48': 'Zeitstempel',
    'A50': 'Gesperrt',
    'A59': 'Aktiv',

    // Darstellung und Format
    'A145': 'Anzeigeformat',
    'A147': 'Darstellung',
    'A148': 'Darstellungsart',
    'A149': 'Symboldarstellung',
    'A150': 'Textdarstellung',

    // Objekteigenschaften
    'A182': 'Objekttyp',
    'A183': 'Objektklasse',
    'A184': 'Objektkategorie',
    'A185': 'Anschlussbezeichnung',
    'A186': 'Anschlussbeschreibung',
    'A187': 'Funktionstext',
    'A188': 'Technische Kennzeichen',
    'A189': 'Gerätekennzeichen',
    'A190': 'Max Position',
    'A191': 'Min Position',
    'A192': 'Orientierung',
    'A193': 'Winkel',
    'A194': 'Beschreibung',
    'A195': 'Langtext',

    // Artikel und Bestellung
    'A200': 'Artikelnummer',
    'A201': 'Hersteller',
    'A202': 'Herstellerbezeichnung',
    'A203': 'Lieferant',
    'A204': 'Bestellnummer',
    'A205': 'Preis',
    'A206': 'Lieferzeit',
    'A207': 'Gewicht',
    'A208': 'Maße',

    // Elektrische Eigenschaften
    'A300': 'Nennspannung',
    'A301': 'Nennstrom',
    'A302': 'Leistung',
    'A303': 'Frequenz',
    'A304': 'Phasen',
    'A305': 'Schutzart',
    'A306': 'Isolationsklasse',
    'A307': 'Kurzschlussfestigkeit',

    // Ebenen
    'A404': 'Ebene',
    'A405': 'Ebenennummer',
    'A406': 'Ebenentyp',
    'A407': 'Ebenensichtbarkeit',
    'A408': 'Ebenenfarbe',
    'A409': 'Ebenenstil',

    // Projektverwaltung
    'A431': 'Projektversion',

    // Verbindungen und Kabel
    'A500': 'Kabeltyp',
    'A501': 'Kabelbezeichnung',
    'A502': 'Kabellänge',
    'A503': 'Kabelquerschnitt',
    'A504': 'Adernzahl',
    'A505': 'Schirmung',
    'A506': 'Verlegeart',

    // Klemmen und Anschlüsse
    'A600': 'Klemmenbezeichnung',
    'A601': 'Klemmentyp',
    'A602': 'Klemmenfarbe',
    'A603': 'Anschlussnummer',
    'A604': 'Anschlusstyp',
    'A605': 'Potenzial',

    // GUIDs und Referenzen
    'A699': 'GUID',
    'A700': 'UUID',
    'A701': 'Externe Referenz',
    'A702': 'Interne Referenz',

    // Positionierung
    'A751': 'Skalierung X',
    'A752': 'Skalierung Y',
    'A753': 'Rotation',
    'A754': 'Spiegelung',
    'A762': 'X/Y Position (Format: "X/Y", z.B. "44/232"; Y wächst nach OBEN; nach unten = Y verkleinern)',
    'A763': 'Breite',
    'A764': 'Höhe',
    'A765': 'Tiefe',

    // Querverweise
    'A792': 'Verbindung',
    'A793': 'Querverweis Typ',
    'A794': 'Querverweis Ziel',
    'A795': 'Querverweis Text',

    // SPS/PLC
    'A800': 'SPS-Adresse',
    'A801': 'SPS-Typ',
    'A802': 'Eingangsadresse',
    'A803': 'Ausgangsadresse',
    'A804': 'Merkerbyte',
    'A805': 'Datenbaustein',

    // Eigenschaften Objekte
    'A1061': 'Eigenschaft 1',
    'A1063': 'Eigenschaft 2',
    'A1101': 'Seitentyp',
    'A1102': 'Seitenbeschreibung',
    'A1103': 'Seitenname',

    // Symbole
    'A1261': 'Symbolnummer',
    'A1262': 'Symboltyp',
    'A1263': 'Symbolvariante',
    'A1264': 'Symbolbibliothek',
    'A1265': 'Symbolname',

    // Anschlüsse
    'A1381': 'Anschluss 1',
    'A1382': 'Anschluss 2',
    'A1383': 'Anschluss 3',
    'A1384': 'Anschluss 4',
    'A1385': 'Anschluss 5',
    'A1386': 'Anschlusspunkt Links',
    'A1387': 'Anschlusspunkt Rechts',
    'A1388': 'Anschlusspunkt Oben',
    'A1389': 'Anschlusspunkt Unten',

    // Zusätzliche aus Beispiel-XML
    'A2489': 'Zusatzinfo',
    'A4023': 'Makroname',
    'A4043': 'Makroversion',
    'A4049': 'Bearbeitungsstatus',
    'A4068': 'Zusatzattribut',

    // P-Attribute (Projekteigenschaften / Geräteeigenschaften)
    'P10185': 'Projekt-ID',
    'P11006': 'Projektstatus',
    'P11011': 'Projektpfad',
    'P11012': 'Seitenzähler',
    'P11020': 'Ersteller',
    'P11021': 'Erstelldatum',
    'P11022': 'Bearbeiter',
    'P11024': 'Änderungsdatum',
    'P11037': 'Version',
    'P11048': 'Freigabe',
    'P11050': 'Prüfstatus',
    'P20011': 'Funktionstext (Format: ??_??@TEXT;)',
    'P20013': 'BMK Kennbuchstabe (Prefix)',
    'P20014': 'BMK Zählnummer',
    'P20027': 'Funktionstext',
    'P20030': 'Anzeige',
    'P20034': 'Querverweisart',
    'P20035': 'Querverweisformat',
    'P20100_1': 'Artikelnummer',
    'P20101_1': 'Artikelnummer Typ',
    'P20102_1': 'Artikelnummer Zähler',
    'P20216': 'Anschlussbezeichnung',
    'P20228': 'Potentialtyp',
    'P20280': 'Kabeltyp',
    'P20808': 'Artikelnummer (alternativ)',
};

/**
 * Get human-readable label for an EPLAN attribute code.
 * @param {string} attrName - e.g. 'P20013'
 * @returns {string} Label or the original code if unknown
 */
export function getAttributeLabel(attrName) {
    return EPLAN_ATTRIBUTE_LABELS[attrName] || attrName;
}
